<app-breadcrumb [master]="'Należności'" [parentName]="'Należności'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
    <app-receivables-imports-row-details-view  [receivablesImportsRow]="receivablesImportRow"  (changed)="loadReceivablesImportsRow()" ></app-receivables-imports-row-details-view>

  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [receivablesImportsRow]="receivablesImportRow"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
